import { rumba } from "../utils/symbols";
import { useApp } from "../context/useApp";
import { processTableLayout, _ } from "../utils/helpers";
import { TableObject } from "../types";
import { TABLE_MAP_ROTATIONS } from "../utils/symbols";
import { useDefaultDialogs } from "./useDefaultDialogs";

export const useTableLayoutRefresh = () => {

    const {
        state: { shifts, booking, layout, venueData},
        actions: { updateLayout}
    } = useApp()

    const defaultDialogs = useDefaultDialogs()

    function handleCompleteResponse(tables: TableObject[]) {

        if (!venueData) return

        const occupiedTablesIds: number[] = [];
        const result = processTableLayout(
            tables,
            50,
            50,
            TABLE_MAP_ROTATIONS[booking.venueId],
            1,
            venueData
        );
        result.processedTables.forEach(table => occupiedTablesIds.push(table.id));
        updateLayout(result);
        return occupiedTablesIds;
    }
    
    function handleLiteResponse(occupiedTablesIds: number[]) {

        updateLayout({
            ...layout,
            processedTables: layout.processedTables.map(table => ({
                ...table,
                occupied: occupiedTablesIds.includes(table.id) ? 1 : 0
            }))
        });
        return occupiedTablesIds;
    }
    
    async function checkBookingTables(occupiedTablesIds: number[]) {

        if (booking.shiftId === 0 || booking.eventId === 0) return

        const response2 = await rumba.getShifts(booking.date)
        if (response2.result !== 'ok') {
            console.warn('Could not get shifts')
            return false
        }

        const shift = response2.shifts.find((shift) => shift.id === booking.shiftId)
        if (!shift) {
            console.warn('shift not found')
            return false
        }

        if (shift.webOpen === 0) {
            console.warn('shift was closed during booking proccess')
            return false
        }

        if (booking.getOccupiedZones().some((zone) => shift[`${zone}Open` as keyof typeof shift] === 0)) {
            console.warn('some occupied zone have been closed during booking proccess')
            return false
        }

        if (new Date(`${booking.date.split('T')[0]}T${shift.time}:00`).getTime() <= Date.now()){
            console.warn('shift is before current time')
            return false
        }

        const seatsHaveBeenSelectedBySomeoneElse = occupiedTablesIds.some(id => booking.getTable(id))
        if (seatsHaveBeenSelectedBySomeoneElse) {
            console.warn('seats have been selected by someone else')
            return false
        }

        return true
    }

    async function refresh(forceEventId?: number): Promise<{available: boolean}> {

        
        if (!venueData) return cancel()
        const eventId = forceEventId || booking.eventId || shifts[0].eventId

        const response = await rumba.getVenueTableLayout(
            eventId, 
            booking.locator, 
            // {lite: layout.processedTables.length > 0}
            {lite: false}
        )
        if (response.result !== 'ok') return cancel()

        const occupiedTablesIds = response.type === 'complete' ?
            handleCompleteResponse(response.tables)
            :
            handleLiteResponse(response.tables)

        if (!occupiedTablesIds) return cancel()
            
        if (booking.shiftId && booking.tables.length) {
            const ok = checkBookingTables(occupiedTablesIds)
            if (!ok) return cancel()
        }

        return {available: true}
    }
    
    const cancel = () => {
        defaultDialogs.show('no-tables')
        return {available: false}
    }

    return { refresh }
}